const TIMER_INTERVAL = 1; // 1ms

function startTimer() {
  
  const timerElement = document.querySelector(".time");
  timerElement.textContent = "0";

  const startTime = performance.now();

  const intervalId = setInterval(() => {
    const elapsedTime = performance.now() - startTime;
    timerElement.textContent = `${Math.floor(elapsedTime)}`;
  }, TIMER_INTERVAL);

  return intervalId;
}

function stopTimer(intervalId) {
  clearInterval(intervalId);
}

export { startTimer, stopTimer };